import { render, staticRenderFns } from "./Borradores.vue?vue&type=template&id=12e2fb16&scoped=true&"
import script from "./Borradores.vue?vue&type=script&lang=js&"
export * from "./Borradores.vue?vue&type=script&lang=js&"
import style0 from "./Borradores.vue?vue&type=style&index=0&id=12e2fb16&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12e2fb16",
  null
  
)

export default component.exports